import React, { useState, useEffect } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginButton from "../components/login";
import "../styles.css";
import axios from "axios";
import { DB_HOST, ENDP_PORT } from "../global_variables";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import bcrypt from "bcryptjs";
import { API_IP } from "../global_variables";
import { randomNumber } from "../functions/RandomNumber";
import { amityLogin } from "./Amity/AmityProvider.ts";
const LoginForm = ({ setUser, setLogin, loggedIn }) => {
  const [logindata, setLogindata] = useState({ email: "", password: "" }); // "ogin data is just thye email and password.
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Bool for is the user is logged in.
  const [deviceToken, setDeviceToken] = useState("");
  const [loginOptions, setLoginOptions] = useState(false); // This is used to determine if the login options are shown.
  const [loginMethods, setLoginMethods] = useState(""); // This is used to determine which login methods are shown.
  const imageNumber = randomNumber(); // This is no longer used.
  const chooseMethods = (method) => {
    // This function is used to choose the login method.
    console.log("Method chosen: ", method);
    setLoginOptions(true);
    setLoginMethods(method);
  };
  const goBackOptions = () => {
    // This function is used to go back to the login options.
    setLoginOptions(false);
    setLoginMethods("");
  };
  const navigate = useNavigate();
  // Retrieves the users device token.
  useEffect(() => {
    // Generate the device token once when the component mounts
    setDeviceToken(uuidv4());
  }, []);

  // Handles the event when the user click the "Login" button.
  const handleLoginButtonClick = async (e) => {
    e.preventDefault();

    const email = document.getElementById("email").value;
    let password = document.getElementById("password").value;
    const rememberMe = document.getElementById("rememberMe").checked;
    const storage = rememberMe ? localStorage : sessionStorage;
    if (email == "" || password == "") {
      alert("Please enter your email/username and password!");
      return;
    }
    let newLogindata = { email, password };
    setLogindata(newLogindata);

    // const hashedPassword = await bcrypt.hash(password, 10);
    // password = hashedPassword
    // make login logic
    const loginURL = `${API_IP}/api/login/`;
    const requestBody = {
      username: email.trim(),
      password: password.trim(),
      device_token: deviceToken.trim(),
    };

    try {
      const response = await axios.post(loginURL, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = response.data;

      // Store JWT token in local storage
      storage.setItem("token", data.token);
      storage.setItem("username", data.username);
      storage.setItem("userId", data.userId);
      storage.setItem("isAdmin", data.isAdmin);
      setLogin(true);
      try {
        await amityLogin("A" + data.userId, data.username);
      } catch (error) {
        console.log("Amity login failed (LoginForm):", error);
      }
      navigate("/main", {
        state: { user: { email: email, username: data.username } },
      });

      setUser({ username: data.username, userId: data.userId });

      console.log("Login successful:", data);
      // Handle successful login (e.g., navigate to another page, store token, etc.)
    } catch (error) {
      console.error("Error logging in:", error);
      console.error("Error logging in:", error);
      console.error("Response Data: ", error.response?.data);
      console.error("Status Code: ", error.response?.status);
      console.error("Headers: ", error.response?.headers);
      switch (error.response?.data) {
        case "Unauthorized":
          alert("Your email or password is not valid. Please try again!");
          break;
        default:
          alert("Try again later");
          break;
      }
      // Handle login error (e.g., show error message to the user)
    }
  };

  // Password handling will probably require changing something here.
  // We should use a hashing function.
  return (
    <>
      <div className="contentContainer">
        <div className="loginFormContainer">
          <div className="titleContainer">
            <h1>LOGIN</h1>
          </div>

          <form id="loginForm" className="inputForm">
            {!loginOptions ? (
              <>
                <a
                  className="loginOptionsContainer"
                  onClick={() => chooseMethods("icaresolution")}
                >
                  <img
                    src={require("./../images/iCareVillage_logo.webp")}
                    alt="Google Logo"
                    className="loginOptionsLogo"
                  />
                  Login with iCareSolution
                </a>
                <a
                  className="loginOptionsContainer"
                  onClick={() => chooseMethods("gmail")}
                >
                  <img
                    src={require("./../images/google-icon.png")}
                    alt="Google Logo"
                    className="loginOptionsLogo"
                  />
                  Login With Gmail
                </a>
              </>
            ) : (
              <>
                {loginMethods === "icaresolution" ? (
                  <>
                    <div className="loginiCareContainer">
                      <p>Email/Username</p>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        placeholder="Email address"
                        className="inputText"
                      />
                      <p>Password</p>
                      <input
                        id="password"
                        type="password"
                        name="password"
                        placeholder="Password"
                        className="inputText"
                      />

                      <div className="flexRow">
                        <div className="loginAssistContainer">
                          <div>
                            <input
                              id="rememberMe"
                              type="checkbox"
                              name="rememberMe"
                              className="inputCheckbox"
                            />
                            <label for="rememberMe">Remember Me</label>
                          </div>
                          <a
                            className="SignUpText decorationNone"
                            href="/forgotpassword"
                          >
                            Forgot Password
                          </a>
                        </div>
                      </div>
                      <div className="login-button-container">
                        <button
                          className="loginButton button"
                          onClick={handleLoginButtonClick}
                        >
                          Login
                        </button>
                      </div>
                    </div>

                    <a
                      className="loginOptionsContainer"
                      onClick={() => goBackOptions()}
                    >
                      Back
                    </a>
                  </>
                ) : (
                  loginMethods === "gmail" && (
                    <div className="OAuthContainer">
                      <GoogleOAuthProvider clientId="168590105791-87i5ulsl54rogj7v9a5h4vki2tifv7kt.apps.googleusercontent.com">
                        <LoginButton
                          setLogin={setLogin}
                          setUser={setUser}
                          className="googleOAuth"
                        />
                      </GoogleOAuthProvider>
                      <a
                        className="loginOptionsContainer"
                        onClick={() => goBackOptions()}
                      >
                        Back
                      </a>
                    </div>
                  )
                )}
              </>
            )}
          </form>
          <div className="flexRow">
            <p>----------- OR -----------</p>
            <a className="SignUpText" href="/register/">
              Sign up with iCareSolution
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginForm;
